import { calculateExplosionImpact } from '../common/physics.js';

export function createExplosion(x, y, radius, maxDamage, knockbackForce, game) {
  // 1. Carve the terrain canvas and update collision mask
  game.carveTerrain(x, y, radius);
  
  // 2. Play Audio
  if (radius > 70) {
    game.audio.play('holy_explosion');
  } else {
    game.audio.play('explosion');
  }

  // 3. Spawn Visual Particles
  game.particles.spawnBurst(x, y, 'fire', Math.round(radius * 0.4));
  game.particles.spawnBurst(x, y, 'smoke', Math.round(radius * 0.5));
  
  // Camera screenshake
  if (game.camera) {
    const shakeAmt = radius > 75 ? 15 : (radius > 55 ? 9 : 5);
    game.camera.shake = Math.max(game.camera.shake || 0, shakeAmt);
  }
  
  // 4. Delegate math and state updates to shared module
  calculateExplosionImpact(
    x, y, radius, maxDamage, knockbackForce,
    game.worms, game.projectiles,
    (worm, damage) => {
      worm.damage(damage);
      game.particles.spawnText(worm.x, worm.y - 18, `-${damage}`, '#f87171');
    },
    (worm, vx, vy) => {
      worm.vx += vx;
      worm.vy += vy;
      worm.isFalling = true;
      if (game.camera && (Math.hypot(worm.vx, worm.vy) > 1.2 || worm.health <= 0)) {
        game.camera.target = worm;
      }
    },
    (proj, vx, vy) => {
      proj.vx += vx;
      proj.vy += vy;
    }
  );
}
